// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicy_root__qdFtZ","section":"PrivacyPolicy_section__X7MOB","text__privacy":"PrivacyPolicy_text__privacy__yLRzj"};